var exports = {
  "zr": "root__JbVNWk",
  "aY": "headerButton__1UH__O",
  "lW": "summaryRow__pBs7Iu",
  "s6": "summaryLeft__Y9x0vX",
  "VH": "summaryRight__FoTcqv",
  "rf": "body__9AwBCy",
  "Yb": "diffPanel__Z3xKoE",
  "hL": "fileTreePanel__ExI8Xj",
  "mL": "fileTreePanelLeft__25inno",
  "nT": "fileTreeResizeHandle__RvrzEL",
  "zt": "diffContainer__czvm1P",
  "ip": "diffPreview__3ydC3k",
  "oA": "noWrap__28uloF",
  "Lq": "loading__GV2XHo",
  "p$": "emptyState__3Rdaz2",
};

module.exports = exports;
